export default {
      id: "help-usage",
      viewBox: "0 0 35.21 43.09",
      url: __webpack_public_path__ + "img/icons.0fe16570.svg#help-usage",
      toString: function () {
        return this.url;
      }
    }